const ITRVL = 'itrvl';

// Naming the institution and last4 inside the sentence keeps the authorization
// legible on its own, without depending on the account being rendered beside it.
const describeAccount = ({ bankName, last4 }) => {
  if (bankName && last4) return `your ${bankName} account ending in ${last4}`;
  if (last4) return `your bank account ending in ${last4}`;
  if (bankName) return `your ${bankName} account`;
  return 'the bank account above';
};

// itrvl holds the Stripe account that initiates the debit, so it is the originator
// Nacha requires the mandate to name. The agency is the merchant the payer bought from
// and the party they serve notice on, and appears on the bank statement descriptor.
const describeOriginator = agencyName => (agencyName === ITRVL ? ITRVL : `${ITRVL} (the payment partner of ${agencyName})`);

const authorizationTerms = ({ agencyName, bankName, last4 }) =>
  `${describeOriginator(agencyName)} to debit ${describeAccount({ bankName, last4 })} for any amount owed for charges arising from your use of ${agencyName}'s services and/or purchase of products from ${agencyName}, pursuant to ${agencyName}'s website and terms, until this authorization is revoked.`;

const revocationTerms = agencyName => `this authorization at any time by providing notice to ${agencyName} with 30 (thirty) days notice.`;

// The payer's browser shows this text and the API re-derives it when recording the
// payment, so both sides MUST resolve agencyName from the itinerary's agency and apply
// the same fallback here — a divergence would record wording the payer never saw.
const mandateAgencyName = agencyName => agencyName || ITRVL;

// Nacha requires the payer to affirmatively accept debit authorization terms before
// the debit is initiated. The agency is the named originator.
export const achMandatePrompt = ({ agencyName, bankName, last4 }) => {
  const name = mandateAgencyName(agencyName);
  return `By checking this box, you authorize ${authorizationTerms({ agencyName: name, bankName, last4 })} You may amend or cancel ${revocationTerms(name)}`;
};

// Restates the accepted authorization once the payment method section collapses, so
// the terms stay on screen through checkout rather than only at the moment of consent.
export const achMandateRecord = ({ agencyName, bankName, last4 }) => {
  const name = mandateAgencyName(agencyName);
  return `You have authorized ${authorizationTerms({ agencyName: name, bankName, last4 })} You can amend or cancel ${revocationTerms(name)}`;
};
